/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { Platform, TouchableOpacity, View } from "react-native";
import Icon from "react-icons-kit";
import { circle } from "react-icons-kit/fa/circle";

import { Text } from "UpduoLibrary";
import {
  skaleLinkBlue,
  skaleMainBlue,
  skaleWebBackgroundGray,
  skaleWebTextBackgroundLightGray,
  colorWithOpacity,
} from "config/UpduoColors";
import { getGraphColor } from "config/Utilities";

export default function SkillListing({
  skillObject,
  currentSkillId,
  _handleGetSkillDetail,
}) {
  const [isHovering, setIsHovering] = useState(false);

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10,
      }}
    >
      <View
        style={[
          {
            borderWidth: 1,
            borderRadius: 8,
            borderColor: skaleWebBackgroundGray,
            paddingVertical: 5,
            width: window.innerWidth * 0.5 - 170,
            minWidth: 400,
            flexDirection: "row",
            backgroundColor: skaleWebTextBackgroundLightGray,
          },
        ]}
      >
        <View
          style={{
            width: 30,
            borderColor: skaleWebBackgroundGray,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text>{`${skillObject.order + 1}.`}</Text>
        </View>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            padding: 10,
            flexShrink: 1,
          }}
        >
          <div
            style={{
              color: getGraphColor(skillObject.name),
              paddingBottom: 2.5,
            }}
          >
            <Icon size={15} icon={circle} />
          </div>
          <View style={{ width: 10 }} />
          <TouchableOpacity
            {...Platform.select({
              web: {
                onMouseEnter: () => {
                  setIsHovering(true);
                },
                onMouseLeave: () => {
                  setIsHovering(false);
                },
              },
            })}
            onPress={() => {
              _handleGetSkillDetail(skillObject.id);
            }}
          >
            <Text
              style={{
                color: colorWithOpacity(
                  isHovering || skillObject.id === currentSkillId
                    ? skaleLinkBlue
                    : skaleMainBlue,
                  skillObject.isPublished ? 1 : 0.2
                ),
              }}
            >
              {skillObject.name}
            </Text>
          </TouchableOpacity>
        </View>
        <View style={{ flex: 1 }} />
      </View>
    </View>
  );
}
